import tracyPic from "@/public/images/artists/tracy.png";
import { Artist } from "@/types/types";

export const tracy = {
  id: "153",
  name: "Tracy",
  image: tracyPic,
  description: `Tracy's voice, with its warm timbre and a slight huskiness, possesses an androgynous charm and a seemingly effortless range. His delivery is deliberate, distinguished by smooth, nuanced transitions that are unmistakably his own.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftracy-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Afrobeat", "Soul", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 68,
      },
      sweetSpot: 59,
    },
  },
} as const satisfies Artist;
